/**
 * Marcel – Vidde/Lengde-veljar for jeans (v2)
 * Deler storleikar som "29/32" i to rader: Vidde (W) og Lengde (L).
 * Slår berre inn når ALLE storleikar er NN/30, NN/32 eller NN/34 og det finst minst to lengder.
 * Produktdata blir ikkje endra: skriptet styrer temaets eigne (skjulte) storleiksknappar.
 * v2: fri rekkjefølgje, held på val ved konflikt, autoval, ingen blink. Lengd har same knappar som vidde.
 * All tekst kunden ser er på bokmål.
 */
(function () {
  if (window.__wlSplitInit) return;
  window.__wlSplitInit = true;

  var RE = /^(\d{2})\/(30|32|34)$/;
  var state = {};
  var uid = 0;

  function num(a, b) { return Number(a) - Number(b); }
  function P(t) { return t === 'w' ? 'W' : 'L'; }

  function injectStyle() {
    if (document.getElementById('wl-split-style')) return;
    var s = document.createElement('style');
    s.id = 'wl-split-style';
    s.textContent =
      '.wl-hidden{display:none!important}' +
      '.wl-split{margin-bottom:8px}' +
      '.wl-split .wl-row{margin:0 0 24px}' +
      '.wl-split .wl-head{display:flex;justify-content:space-between;align-items:baseline;gap:12px;margin:0 0 10px}' +
      '.wl-split .wl-head .label{margin:0}' +
      '.wl-split .wl-val{font-weight:400;opacity:.65;margin-left:8px}' +
      '.wl-split .wl-none+.opt-label{opacity:.35}' +
      '.wl-split .wl-out+.opt-label{text-decoration:line-through;opacity:.55}' +
      '.wl-split .wl-gone,.wl-split .wl-gone+.opt-label{display:none!important}' +
      '.wl-split .wl-conf+.opt-label{outline:1.5px dashed #1A1A1A;outline-offset:-4px}' +
      '.wl-split .wl-hint{font-size:14px;margin:-8px 0 16px;color:#6b665c}' +
      '.wl-split .wl-hint.is-warn{color:#A33A2B}' +
      '.wl-split .wl-hint:empty{display:none}' +
      '.wl-split .wl-row--missing .label{color:#A33A2B}' +
      '.wl-split .wl-row--missing .option-selector__btns{animation:wl-shake .35s ease}' +
      '@keyframes wl-shake{0%,100%{transform:none}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}' +
      '.wl-needs-size .shopify-payment-button,.wl-needs-size shopify-accelerated-checkout{display:none!important}';
    document.head.appendChild(s);
  }

  function rowHtml(type, label, values, id) {
    var h = '<div class="wl-row" data-wl-row="' + type + '">' +
      '<div class="wl-head"><span class="label">' + label + '<span class="wl-val"></span></span></div>' +
      '<div class="option-selector__btns flex flex-wrap">';
    values.forEach(function (v) {
      var iid = 'wl-' + id + '-' + type + '-' + v;
      h += '<input type="radio" class="opt-btn visually-hidden focus-label" form="wl-none"' +
        ' name="wl-' + id + '-' + type + '" id="' + iid + '" value="' + v + '" data-wl="' + type + '">' +
        // data-preloaded hindrar at temaet prøver å førehandslaste våre knappar
        '<label for="' + iid + '" class="opt-label opt-label--btn btn relative text-center" data-preloaded="true">' +
        '<span class="js-value">' + v + '</span></label>';
    });
    return h + '</div></div>';
  }

  function sectionOf(el) {
    return el.closest('.js-quickbuy') || el.closest('.cc-featured-product') || el.closest('.shopify-section');
  }

  function setBlocked(picker, blocked) {
    var sec = sectionOf(picker);
    if (sec) sec.classList.toggle('wl-needs-size', blocked);
  }

  // Stopp kjøp til ein gyldig kombinasjon er valt, og vis kva som manglar
  function guard(e) {
    var btn = e.type === 'submit' ? e.target.querySelector('[name="add"]') : e.target.closest && e.target.closest('[name="add"]');
    if (!btn) return;
    var sec = sectionOf(btn);
    var wrap = sec && sec.querySelector('.wl-split');
    if (!wrap || !wrap.__wlState || wrap.__wlState.chosen) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (e.type === 'click') wrap.__wlShowMissing();
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);

  function enhance(picker) {
    if (picker.querySelector('.wl-split')) return;
    var fs = picker.querySelector('fieldset.option-selector[data-selector-type="listed"]');
    if (!fs) return;
    // Viss produktet ikkje passar, vis den vanlege rada (CSS-en i <head> kan ha skjult ho)
    function bail() { fs.classList.add('wl-off'); }
    if (picker.dataset.optionCount !== '1') return bail();
    var inputs = Array.prototype.slice.call(fs.querySelectorAll('input.js-option'));
    if (inputs.length < 2) return bail();

    var combos = {};
    var ws = {};
    var ls = {};
    for (var i = 0; i < inputs.length; i++) {
      var m = RE.exec(String(inputs[i].value).trim());
      if (!m) return bail();
      combos[m[1] + '/' + m[2]] = inputs[i];
      ws[m[1]] = 1;
      ls[m[2]] = 1;
    }
    var wList = Object.keys(ws).sort(num);
    var lList = Object.keys(ls).sort(num);
    if (lList.length < 2) return bail();

    injectStyle();

    // Med «Prune» skjuler butikken utselde storleikar, så utselt = ikkje tilgjengeleg
    var prune = picker.dataset.availability === 'prune';
    function avail(w, l) { var c = combos[w + '/' + l]; return !!c && !c.classList.contains('is-unavailable'); }
    function exists(w, l) { return prune ? avail(w, l) : !!combos[w + '/' + l]; }
    function pair(t, v, x) { return t === 'w' ? [v, x] : [x, v]; }

    var isMain = !picker.closest('.js-quickbuy') && !picker.closest('.cc-featured-product');
    var key = (picker.dataset.url || '') + (isMain ? '|main' : '|other');
    var st = state[key];
    var checked = fs.querySelector('input.js-option:checked');
    if (!st) {
      st = state[key] = { w: null, l: null, chosen: false, msg: '', warn: false };
      if (isMain && checked && new URLSearchParams(window.location.search).has('variant')) {
        var cm = RE.exec(String(checked.value).trim());
        if (cm) { st.w = cm[1]; st.l = cm[2]; st.chosen = true; }
      }
    }

    uid += 1;
    var wrap = document.createElement('div');
    wrap.className = 'wl-split';
    wrap.innerHTML =
      rowHtml('w', 'Vidde (W)', wList, uid) +
      rowHtml('l', 'Lengde (L)', lList, uid) +
      '<p class="wl-hint" aria-live="polite"></p>';
    fs.parentNode.insertBefore(wrap, fs.nextSibling);
    fs.classList.add('wl-hidden');

    // Flytt eventuell storleiksguide-lenkje inn i Vidde-overskrifta
    var chart = fs.querySelector('.flex.justify-between > :not(legend)');
    if (chart) wrap.querySelector('.wl-head').appendChild(chart);

    function render() {
      wrap.querySelectorAll('input[data-wl]').forEach(function (r) {
        var t = r.dataset.wl;
        var v = r.value;
        var o = t === 'w' ? st.l : st.w;
        var others = t === 'w' ? lList : wList;
        var anyAvail = others.some(function (x) { var p = pair(t, v, x); return avail(p[0], p[1]); });
        var cls = '';
        if (!anyAvail) {
          cls = prune ? 'gone' : 'out';
        } else if (o) {
          var p = pair(t, v, o);
          if (!exists(p[0], p[1])) cls = 'none';
          else if (!avail(p[0], p[1])) cls = 'out';
        }
        r.classList.toggle('wl-none', cls === 'none');
        r.classList.toggle('wl-out', cls === 'out');
        r.classList.toggle('wl-gone', cls === 'gone');
        r.checked = v === st[t];
        var conf = false;
        if (r.checked && o) { var q = pair(t, v, o); conf = !exists(q[0], q[1]); }
        // Berre den sist ikkje-valde sida får stipla ramme
        r.classList.toggle('wl-conf', conf && st.conf === t);
      });
      wrap.querySelector('[data-wl-row="w"] .wl-val').textContent = st.w || '';
      wrap.querySelector('[data-wl-row="l"] .wl-val').textContent = st.l || '';
      wrap.querySelectorAll('.wl-row--missing').forEach(function (row) {
        var type = row.dataset.wlRow;
        if ((type === 'w' && st.w) || (type === 'l' && st.l)) row.classList.remove('wl-row--missing');
      });
      var hint = wrap.querySelector('.wl-hint');
      hint.textContent = st.msg;
      hint.classList.toggle('is-warn', !!st.warn);
      setBlocked(picker, !st.chosen);
    }

    function pick(t, v) {
      var o = t === 'w' ? 'l' : 'w';
      st.msg = '';
      st.warn = false;
      st.conf = null;
      if (st[t] === v) {
        st[t] = null; // Trykk på valt knapp fjernar valet
      } else {
        st[t] = v;
        var others = t === 'w' ? lList : wList;
        var okOpts = others.filter(function (x) { var p = pair(t, v, x); return avail(p[0], p[1]); });
        var exOpts = others.filter(function (x) { var p = pair(t, v, x); return exists(p[0], p[1]); });
        var autoMsg = function (x) {
          return P(o) + x + ' er valgt automatisk, fordi det er den eneste ' +
            (o === 'l' ? 'lengden' : 'vidden') + ' i ' + P(t) + v + '.';
        };
        if (st[o]) {
          var p = pair(t, v, st[o]);
          if (!exists(p[0], p[1])) {
            if (okOpts.length === 1) {
              st[o] = okOpts[0];
              st.msg = autoMsg(okOpts[0]);
            } else {
              st.msg = P(o) + st[o] + ' er ikke tilgjengelig i ' + P(t) + v + '. Velg en annen ' +
                (o === 'l' ? 'lengde' : 'vidde') + '.';
              st.warn = true;
              st.conf = o;
            }
          }
        } else if (exOpts.length === 1 && okOpts.length === 1) {
          st[o] = okOpts[0];
          st.msg = autoMsg(okOpts[0]);
        }
      }
      var target = st.w && st.l && exists(st.w, st.l) ? combos[st.w + '/' + st.l] : null;
      st.chosen = !!target;
      render();
      if (target && !target.checked) {
        target.checked = true;
        target.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: false, detail: { noFocus: true } }));
      }
    }

    wrap.__wlState = st;
    wrap.__wlShowMissing = function () {
      var missing = !st.w ? 'w' : 'l';
      var row = wrap.querySelector('[data-wl-row="' + missing + '"]');
      if (!st.warn) st.msg = missing === 'w' ? 'Velg vidde' : 'Velg lengde';
      st.warn = true;
      render();
      row.classList.remove('wl-row--missing');
      void row.offsetWidth; // start animasjonen på nytt
      row.classList.add('wl-row--missing');
      var r = row.getBoundingClientRect();
      if (r.top < 80 || r.bottom > window.innerHeight) row.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    // Klikk: handterer òg trykk på allereie valt knapp (fjernar valet)
    wrap.addEventListener('click', function (e) {
      var lab = e.target.closest && e.target.closest('label[for]');
      if (!lab || !wrap.contains(lab)) return;
      var inp = document.getElementById(lab.htmlFor);
      if (!inp || !inp.dataset.wl) return;
      e.preventDefault();
      pick(inp.dataset.wl, inp.value);
    });
    // Tastatur (piltastar på radioknappar)
    wrap.addEventListener('change', function (e) {
      e.stopPropagation(); // Ikkje la temaet tru at dette er eit variantbyte
      var t = e.target;
      if (!t || !t.dataset.wl) return;
      if (st[t.dataset.wl] !== t.value) pick(t.dataset.wl, t.value);
    });

    render();
  }

  var scanning = false;
  function scan() {
    if (scanning) return;
    scanning = true;
    document.querySelectorAll('variant-picker').forEach(function (p) {
      if (p.dataset.wlFailed) return;
      try {
        enhance(p);
      } catch (err) {
        p.dataset.wlFailed = '1';
        // Feil her skal aldri stoppe kjøp: vis den vanlege storleiksrada
        var f = p.querySelector('fieldset.option-selector');
        if (f) { f.classList.add('wl-off'); f.classList.remove('wl-hidden'); }
        var w = p.querySelector('.wl-split');
        if (w) w.remove();
      }
    });
    scanning = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Køyrer før neste teikning, så den nye rada er på plass før kunden ser noko
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
}());
